import Vue from 'vue';
import Router from 'vue-router';
import { Message } from 'element-ui';
import store from '../store';
import { getToken } from '../utils/auth';

/* 布局组件 */
import Layout from '../views/layout/Layout';
import LoginPage from '../views/Login/LoginPage';

const IImport = require(`./_import_${process.env.NODE_ENV}`);

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
};

const routes = [
    {
        path: '',
        redirect: { name: 'Home' }
    },
    // 登录
    {
        path: '/loginPage',
        name: 'LoginPage',
        component: LoginPage,
        redirect: { name: 'Login' },
        children: [
            {
                path: 'login',
                name: 'Login',
                component: IImport('Login/components/Login')
            },
            {
                path: 'wxLogin',
                name: 'WxLogin',
                component: IImport('Login/components/WxLogin')
            },
            {
                path: 'register',
                name: 'Register',
                component: IImport('Login/components/Register')
            },
            {
                path: 'forgetPassword',
                name: 'ForgetPassword',
                component: IImport('Login/components/ForgetPassword')
            }
        ]
    },
    // 主页
    {
        path: '/home',
        component: Layout,
        redirect: { name: 'Home' },
        children: [
            {
                path: '',
                name: 'Home',
                component: IImport('Home/Home')
            }
        ]
    },
    // 主页
    {
        path: '/sale',
        component: Layout,
        redirect: { name: 'Sale' },
        children: [
            {
                path: '',
                name: 'Sale',
                component: IImport('Sale/Sale'),
                meta: {
                    noFooter: true,
                },
            }
        ]
    },
    // 工具
    {
        path: '/tool',
        component: Layout,
        redirect: { name: 'Tool' },
        children: [
            {
                path: '',
                name: 'Tool',
                component: IImport('Tool/Tool'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: 'detail/:id?',
                name: 'ToolDetail',
                component: IImport('Tool/components/ToolDetail')
            }
        ]
    },
    // 作品
    {
        path: '/works',
        component: Layout,
        redirect: { name: 'Works' },
        children: [
            {
                path: '',
                name: 'Works',
                component: IImport('Works/Works'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: 'detail/:id?',
                name: 'WorksDetail',
                component: IImport('Works/components/WorksDetail'),
                meta: {
                    notCenterLayout: true,
                }
            }
        ]
    },
    // 经验
    {
        path: '/experience',
        component: Layout,
        redirect: { name: 'Experience' },
        children: [
            {
                path: '',
                name: 'Experience',
                component: IImport('Experience/Experience'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: 'detail/:id?',
                name: 'ExperienceDetail',
                component: IImport('Experience/components/ExperienceDetail'),
                meta: {
                    notCenterLayout: true,
                }
            }
        ]
    },
    // 素材
    {
        path: '/material/:type?',
        component: Layout,
        redirect: { name: 'FreeMaterial' },
        children: [
            {
                path: '/material/detail/:id?',
                name: 'FreeMaterialDetail',
                component: IImport('Material/components/MaterialDetail'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: '/material/author/:id?',
                name: 'FreeMaterialAuthor',
                component: IImport('Material/components/MaterialAuthor'),
                // meta: {
                //     checkToken: true
                // }
            },
            {
                path: '/material/:type?/:subType?',
                name: 'FreeMaterial',
                component: IImport('Material/FreeMaterial'),
                meta: {
                    notCenterLayout: true,
                },
            },
            {
                path: '/material/:type?/:subType?/:format?',
                name: 'FreeMaterialWithFormat',
                component: IImport('Material/FreeMaterial'),
                meta: {
                    notCenterLayout: true,
                },
            },
        ]
    },
    // 找图片
    // {
    //     path: '/findImage',
    //     component: Layout,
    //     redirect: { name: 'FindImage' },
    //     children: [
    //         {
    //             path: '/findImage/detail/:id?',
    //             name: 'FindImageDetail',
    //             component: IImport('FindImage/components/ImageDetail'),
    //             meta: {
    //                 notCenterLayout: true,
    //             }
    //         },
    //         // {
    //         //     path: '/findImage/vip',
    //         //     name: 'FindImageVip',
    //         //     component: IImport('FindImage/components/ImageVip'),
    //         //     meta: {
    //         //         noFooter: true,
    //         //     }
    //         // },
    //         {
    //             path: '/findImage/:type?/:subType?',
    //             name: 'FindImage',
    //             component: IImport('FindImage/FindImage'),
    //             meta: {
    //                 // notCenterLayout: true,
    //             },
    //         },
    //         {
    //             path: '/findImage/:type?/:subType?/:format?',
    //             name: 'FindImageWithFormat',
    //             component: IImport('FindImage/FindImage'),
    //             meta: {
    //                 // notCenterLayout: true,
    //             },
    //         },
    //     ]
    // },
    // 课程
    {
        path: '/courses',
        component: Layout,
        redirect: { name: 'Courses' },
        children: [
            {
                path: '',
                name: 'Courses',
                component: IImport('Courses/Index'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: 'detail/:id',
                name: 'CoursesDetail',
                component: IImport('Courses/Detail'),
                // meta: {
                //     checkToken: true
                // }
            }
        ]
    },
    // 社区
    {
        path: '/forum',
        component: Layout,
        redirect: { path: '/forum/index/0' },
        children: [
            {
                path: '/forum/index/:type?',
                name: 'ForumIndex',
                component: IImport('Forum/Index'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: '/forum/publish/:type?',
                name: 'ForumPublish',
                component: IImport('Forum/Publish'),
                meta: {
                    notCenterLayout: true,
                    checkToken: true
                }
            },
            {
                path: '/forum/my/:type?',
                name: 'MyForum',
                component: IImport('Forum/My'),
                meta: {
                    notCenterLayout: true,
                    checkToken: true
                }
            },
            {
                path: '/forum/detail/:id',
                name: 'ForumDetail',
                component: IImport('Forum/Detail'),
                meta: {
                    notCenterLayout: true,
                }
            }
        ]
    },
    // 源码
    {
        path: '/sourceCode/:type?',
        component: Layout,
        redirect: { name: 'SourceCode' },
        children: [
            {
                path: '/sourceCode/detail/:id?',
                name: 'SourceCodeDetail',
                component: IImport('SourceCode/components/SourceCodeDetail'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: '/sourceCode/author/:id?',
                name: 'SourceCodeAuthor',
                component: IImport('SourceCode/components/SourceCodeAuthor'),
                // meta: {
                //     checkToken: true
                // }
            },
            {
                path: '/sourceCode/:type?/:subType?',
                name: 'SourceCode',
                component: IImport('SourceCode/Index'),
                meta: {
                    notCenterLayout: true,
                    // noFooter: true,
                },
                children:[
                    
                ]
            },
            {
                path: '/sourceCode/:type?/:subType?/:techId?',
                name: 'SourceCodeWithTechId',
                component: IImport('SourceCode/Index'),
                meta: {
                    notCenterLayout: true,
                    // noFooter: true,
                },
            },
        ]
    },
    // 项目案例
    {
        path: '/projectCase/:type?',
        component: Layout,
        redirect: { name: 'ProjectCase' },
        children: [
            {
                path: '/projectCase/detail/:id?',
                name: 'ProjectCaseDetail',
                component: IImport('ProjectCase/Detail'),
                meta: {
                    notCenterLayout: true,
                }
            },
            {
                path: '/projectCase/:type?/:subType?',
                name: 'ProjectCase',
                component: IImport('ProjectCase/Project'),
                // component: IImport('ProjectCase/Project'),
                meta: {
                    notCenterLayout: true,
                    // noFooter: true,
                },
                children:[
                    
                ]
            },
            // {
            //     path: '/projectCase/project/case',
            //     name: 'ProjectCaseProject',
            //     component: IImport('ProjectCase/Project'),
            //     meta: {
            //         notCenterLayout: true,
            //         // noFooter: true,
            //     }
            // }
        ]
    },
    // 个人中心
    {
        path: '/user/:id?',
        component: Layout,
        redirect: { name: 'User' },
        children: [
            {
                path: '',
                name: 'User',
                component: IImport('User/User'),
                meta: {
                    notCenterLayout: true
                }
            }
        ]
    },
    // 修改资料
    {
        path: '/userInfo',
        component: Layout,
        redirect: { name: 'UserInfo' },
        children: [
            {
                path: '',
                name: 'UserInfo',
                component: IImport('UserInfo/UserInfo'),
                redirect: { name: 'BaseInfo' },
                children: [
                    {
                        path: 'baseInfo',
                        name: 'BaseInfo',
                        component: IImport('UserInfo/components/BaseInfo'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'extendInfo',
                        name: 'ExtendInfo',
                        component: IImport('UserInfo/components/ExtendInfo'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'changePwd',
                        name: 'ChangePwd',
                        component: IImport('UserInfo/components/ChangePwd'),
                        meta: {
                            checkToken: true
                        }
                    }
                ]
            }
        ]
    },
    // 用户资料详情页
    {
        path: '/designerInfo/:id',
        component: Layout,
        redirect: { name: 'DesignerInfo' },
        children: [
            {
                path: '',
                name: 'DesignerInfo',
                component: IImport('DesignerInfo/DesignerInfo'),
                redirect: { name: 'DesignerBaseInfo' },
                children: [
                    {
                        path: 'baseInfo',
                        name: 'DesignerBaseInfo',
                        component: IImport('DesignerInfo/components/BaseInfo'),
                    }
                ]
            }
        ]
    },
    // 粉丝
    {
        path: '/follow/:id?',
        component: Layout,
        redirect: { name: 'Follow' },
        children: [
            {
                path: '',
                name: 'Follow',
                component: IImport('Follow/Follow'),
            }
        ]
    },
    // 通知
    {
        path: '/message',
        component: Layout,
        redirect: { name: 'Message' },
        children: [
            {
                path: '',
                name: 'Message',
                component: IImport('Message/Message'),
                meta: {
                    checkToken: true
                }
            }
        ]
    },
    // 上传
    {
        path: '/upload',
        component: Layout,
        redirect: { name: 'Upload' },
        children: [
            {
                path: '',
                name: 'Upload',
                component: IImport('Upload/Upload'),
                redirect: { name: 'UploadWorks' },
                children: [
                    {
                        path: 'works',
                        name: 'UploadWorks',
                        component: IImport('Upload/components/UploadWorks'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'experience',
                        name: 'UploadExperience',
                        component: IImport('Upload/components/UploadExperience'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'case',
                        name: 'UploadCase',
                        component: IImport('Upload/components/UploadCase'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'import',
                        name: 'ImportArticle',
                        component: IImport('Upload/components/ImportArticle'),
                        meta: {
                            checkToken: true
                        }
                    },
                    {
                        path: 'material',
                        name: 'ImportMaterial',
                        component: IImport('Upload/components/UploadMaterial'),
                        meta: {
                            checkToken: true
                        }
                    }
                ]
            }
        ]
    },
    // 底部信息
    {
        path: '/blackboard',
        component: Layout,
        redirect: { name: 'Blackboard' },
        children: [
            {
                path: '',
                name: 'Blackboard',
                component: IImport('Blackboard/Blackboard'),
                redirect: { name: 'AboutUs' },
                children: [
                    {
                        path: 'aboutUs',
                        name: 'AboutUs',
                        component: IImport('Blackboard/components/AboutUs')
                    },
                    {
                        path: 'copyright',
                        name: 'Copyright',
                        component: IImport('Blackboard/components/Copyright')
                    },
                    {
                        path: 'helpCenter',
                        name: 'HelpCenter',
                        component: IImport('Blackboard/components/HelpCenter')
                    },
                    {
                        path: 'userAgreement',
                        name: 'UserAgreement',
                        component: IImport('Blackboard/components/UserAgreement')
                    },
                    {
                        path: 'privacyPolicy',
                        name: 'PrivacyPolicy',
                        component: IImport('Blackboard/components/PrivacyPolicy')
                    },
                    {
                        path: 'buyTreaty',
                        name: 'BuyTreaty',
                        component: IImport('Blackboard/components/BuyTreaty')
                    },
                    {
                        path: 'contract',
                        name: 'Contract',
                        component: IImport('Blackboard/components/Contract')
                    },
                    {
                        path: 'advertise',
                        name: 'Advertise',
                        component: IImport('Blackboard/components/Advertise')
                    }
                ]
            }
        ]
    },
    // 广告
    {
        path: '/advert/:id?',
        component: Layout,
        redirect: { name: 'Advert' },
        children: [
            {
                path: '',
                name: 'Advert',
                component: IImport('Advert/Advert')
            }
        ]
    },
    // 搜索
    {
        path: '/search',
        component: Layout,
        redirect: { name: 'Search' },
        children: [
            {
                path: '',
                name: 'Search',
                component: IImport('Search/Search')
            }
        ]
    },
    // 404
    {
        path: '*',
        name: 'Error',
        component: IImport('Error/Error')
    }
];

const router = new Router({
    mode: 'hash',
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    routes
});

router.beforeEach((to, from, next) => {
    document.title = '数字像素 -可视化设计、开发、定制服务平台';
    if(to.name == 'Login'){
        localStorage.setItem('path', from.path);
    }
    if (to.path) {
        if (window._hmt && !window.location.host.includes('localhost') && !window.location.host.includes('47.92.160.155')) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath]);
        }
    }
    if (getToken()) {
        if (!store.getters.userInfo) {
            store.dispatch('user/getUserInfo');
        }
    }
    if (location.hostname.includes('www.shuzixs.com') && location.protocol === 'http:') {
        window.location.href = `https://www.shuzixs.com/#${to.fullPath}`;
    } else {
        const { checkToken } = to.meta;
        if (checkToken && !getToken()) {
            Message.error('请先登录');
            next({ name: 'Login' });
        } else {
            next();
        }
    }
});

export default router;
